import React, { FC } from "react";
import { StaffFragment } from "@sinch/components/application/StaffDetailPanel/queries.types";
import { Divider, Stack, Typography } from "@mui/material";

/**
 * Inline, divider-separated list of a worker's professions. Renders nothing when the
 * worker has no professions, so the surrounding layout doesn't reserve empty space.
 */
export const ProfessionList: FC<{ professions: StaffFragment["professions"] }> = ({ professions }) => {
  if (!professions?.length) {
    return null;
  }

  return (
    <Stack
      direction="row"
      divider={
        <Divider
          orientation="vertical"
          sx={{
            borderColor: ({ palette }) => palette.grey["800"],
            height: "14px",
            marginRight: "6px !important",
          }}
          variant="middle"
        />
      }
      spacing={0.75}
      sx={{ alignItems: "flex-start", flexWrap: "wrap", mb: 1, mt: 0.5 }}
    >
      {professions.map((profession) => (
        <Typography
          key={profession.id}
          component="span"
          noWrap
          sx={{ lineHeight: "15px", m: 0, p: 0 }}
          variant="descriptionSmall"
        >
          {profession.name}
        </Typography>
      ))}
    </Stack>
  );
};
